export default "__VITE_ASSET__DdmCXPKU__"